import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store' // 引入vuex store实例
import Home from '../views/Home.vue'
import NProgress from "nprogress"
import 'nprogress/nprogress.css'  

Vue.use(VueRouter)

const routes = [
  {
    //首页
    path: '/',
    name: 'home',
    component: Home
  },
  {
    // 测试 音频播放
    path: '/musicView', 
    name: 'musicView',
    component: () => import( '../views/CH_music/musicView.vue')
  },

  {
    // 协会公告（已整合进"新闻公告"统一入口，保留旧地址重定向到对应分类）
    path: '/Notice',
    redirect: '/newsnotice?tab=notice'
  },
  {
    // 协会公告详情
    path: '/Noticedetails', 
    name: 'Noticedetails',
    component: () => import( '../views/Noticedetails.vue')
  },
  {
    //赛事中心
    path: '/move',
    name: 'move',
    component: () => import('../views/move.vue')
  },
  //活动中心（已停用：2026-08-31 整体迁移整合至体智能专区 /fitness"活动中心"标签页，views/activity.vue 已注释）
  // {
  //   path: '/activity',
  //   name: 'activity',
  //   component: () => import('../views/activity.vue')
  // },
  {
    //成绩查询
    path: '/scoreQuery',
    name: 'scoreQuery',
    component: () => import('../views/scoreQuery.vue')
  },
  {
    //赛事中心详情
    path: '/raceDetails',
    name: 'raceDetails',
    component: () => import( '../views/raceDetails.vue')
  },
  {
    // 赛事发布与查看（下拉选赛事查看完整发布信息）
    path: '/matchPublish',
    name: 'matchPublish',
    component: () => import('../views/matchPublish.vue')
  },
  {
    // 服务专区（合作单位卡片 + 服务外链卡片）
    path: '/serviceZone',
    name: 'serviceZone',
    component: () => import('../views/serviceZone.vue')
  },
  {
    // 服务专区（导航栏专区入口路由）
    path: '/services',
    name: 'services',
    component: () => import('../views/serviceZone.vue')
  },
  {
    // 赛事专区（导航栏专区入口路由：已发布赛事列表）
    path: '/events',
    name: 'events',
    component: () => import('../views/matchZone.vue')
  },
  {
    // 体智能专区（Banner轮播 + 内容卡片）
    path: '/fitness',
    name: 'fitness',
    component: () => import('../views/fitness.vue')
  },
  {
    // 合作单位详情（安全提醒后跳转官方网站）
    path: '/partner/:partnerId',
    name: 'partnerDetail',
    component: () => import('../views/partnerDetail.vue')
  },
  {
    // 报名成功页（报名成功自动开通会员身份）
    path: '/signupSuccess',
    name: 'signupSuccess',
    component: () => import('../views/signupSuccess.vue')
  },
  {
    //活动中心详情（活动中心已迁移至体智能专区，详情页保留供 /fitness 活动中心标签跳转使用）
    path: '/activityDetails',
    name: 'activityDetails',
    component: () => import( '../views/activityDetails.vue')
  },
  {
    //申请用章
    path: '/moveYZ',
    name: 'moveYZ',
    component: () => import('../views/moveYZ.vue')
  },
  {
    //申请用章记录页
    path: '/moveRecord',
    name: 'moveRecord',
    component: () => import('../views/moveRecord.vue')
  },


  {
    //赛事活动详情
    path: '/moveactiondetails',
    name: 'moveactiondetails',
    component: () => import('../views/moveactiondetails.vue')
  },

  {
    //新闻公告（导航统一入口：协会公告 + 新闻专区 分类展示，2026-08-31 整合）
    path: '/newsnotice',
    name: 'newsNotice',
    component: () => import( '../views/newsNotice.vue')
  },
  {
    //新闻资讯（已整合进"新闻公告"统一入口，保留旧地址重定向到对应分类）
    path: '/news',
    redirect: '/newsnotice?tab=news'
  },
  {
    //新闻资讯详情
    path: '/newsdetails',
    name: 'newsdetails',
    component: () => import( '../views/newsdetails.vue')
  },
  {
    //组织机构
    path: '/institution',
    name: 'institution',
    component: () => import( '../views/institution.vue')
  },
  {
    //认证机构
    path: '/organ',
    name: 'organ',
    component: () => import( '../views/organ.vue')
  },
  {
    //认证学校
    path: '/school',
    name: 'school',
    component: () => import( '../views/school.vue')
  },
  {
    //认证机构详情
    path: '/organdetails',
    name: 'organdetails',
    component: () => import( '../views/organdetails.vue')
  },
  {
    //认证学校详情
    path: '/schoolDetails',
    name: 'schoolDetails',
    component: () => import( '../views/schoolDetails.vue')
  },
  { 
    // 关于协会
    path: '/about',
    name: 'about',
    component: () => import( '../views/About.vue')
  },
  { // VIP功能
    path: '/vipFunction',
    name: 'vipFunction',
    component: () => import( '../views/vipFunction/index.vue')
  },
  {
    path: '/rubikMemory',
    name: 'rubikMemory',
    component: () => import('../views/vipFunction/rubikMemory/index.vue')
  },
  {
    path: '/angleHome',
    name: 'angleHome',
    component: () => import('../views/vipFunction/rubikMemory/angleHome/index.vue')
  },
  {
    path: '/rubikCubeGame',
    name: 'rubikCubeGame',
    component: () => import('../views/vipFunction/rubikMemory/angleHome/rubikCubeGame.vue')
  },
  {
    path: '/rubikCubeGameThree',
    name: 'rubikCubeGameThree',
    component: () => import('../views/vipFunction/rubikMemory/angleHome/rubikCubeGameThree.vue')
  },
  {
    path: '/angleReruit',
    name: 'angleReruit',
    component: () => import('../views/vipFunction/rubikMemory/angleReruit/index.vue')
  },
  {
    path: '/recruitOnTw',
    name: 'recruitOnTw',
    component: () => import('../views/vipFunction/rubikMemory/angleReruit/recruitOnTw.vue')
  },
  {
    path: '/recruitThree',
    name: 'recruitThree',
    component: () => import('../views/vipFunction/rubikMemory/angleReruit/recruitThree.vue')
  },
  {
    path: '/rubikCubeGameAlgerite',
    name: 'rubikCubeGameAlgerite',
    component: () => import('../views/vipFunction/rubikMemory/rubikCubeGameAlgerite/index.vue')
  },
  {
    path: '/inputFormula',
    name: 'inputFormula',
    component: () => import('../views/vipFunction/inputFormula/index.vue')
  },
  {
    path: '/edgeAngle',
    name: 'edgeAngle',
    component: () => import('../views/vipFunction/inputFormula/edgeAngle.vue')
  },
  {
    path: '/flatDisplay',
    name: 'flatDisplay',
    component: () => import('../views/vipFunction/inputFormula/flatDisplay.vue')
  },
  {
    path: '/highTiming',
    name: 'highTiming',
    component: () => import('../views/vipFunction/highTiming/index.vue')
  },
  {
    path: '/highTimingList',
    name: 'highTimingList',
    component: () => import('../views/vipFunction/highTiming/highTimingList.vue')
  },
  {
    path: '/rubikCubeFigure',
    name: 'rubikCubeFigure',
    component: () => import('../views/vipFunction/highTiming/rubikCubeFigure.vue')
  },
  { 
    // 机构信息中心
    path: '/infostart',
    // name: 'infostart',
    component: () => import( '../views/infostart.vue'),
    children:[
      {
        // 默认子路由  // 我的信息
        path:"/",
        // name: 'infopersoninfor',
        component: () => import( '../views/inforstart/infopersoninfor.vue')
      },
      // {
      //   // 默认子路由 // 机构信息
        
      //   path:"/",
      //   // name: 'infoorganinfor',
      //   component: () => import( '../views/inforstart/infoorganinfor.vue')
      // },
      { 
        // 机构信息
        path: 'infopersoninfor',
        name: 'organInfopersoninfor',
        component: () => import( '../views/inforstart/infopersoninfor.vue')
      },
      { 
        // 机构信息
        path: 'infoorganinfor',
        name: 'infoorganinfor',
        component: () => import( '../views/inforstart/infoorganinfor.vue')
      },
      { 
        // 机构信息
        path: 'update',
        name: 'update',
        component: () => import( '../views/inforstart/update.vue')
      },
      { 
        // 机构风采
        path: 'infoorganstyle',
        name: 'infoorganstyle',
        component: () => import( '../views/inforstart/infoorganstyle.vue')
      },
      { 
        // 我的会员
        path: 'infororganmember',
        name: 'infororganmember',
        component: () => import( '../views/inforstart/infororganmember.vue')
      },
      { 
        // 会员详情
        path: 'infororganmemberdetails',
        name: 'infororganmemberdetails',
        component: () => import( '../views/inforstart/infororganmemberdetails.vue')
      },
      {
        // 会员审核
        path: 'infororganverify',
        name: 'infororganverify',
        component: () => import( '../views/inforstart/infororganverify.vue')
      },
      {
        // 我的报名（团体报名）
        path: 'mysignup',
        name: 'orgMysignup',
        component: () => import( '../views/mysignup.vue')
      },
    ]
  },
  // 默认子路由示例
  // {
  //   path: '/About',
  //   component: About,
  //   redirect: '/About/tab1',
  //   children: [
  //     //需要注意的是：子路由规则不要以/开头
  //     { path: 'tab1', component: Tab1 },
  //     { path: 'tab2', component: Tab2 }
  //   ]
  // },
  {
    // 个人信息中心
    path: '/infostartperson',
    // name: 'infostartperson',
    component: () => import( '../views/infostartperson.vue'),
    children:[
      {
        // 默认子路由  // 我的信息
        path:"/",
        name: 'Infopersoninfor',
        component: () => import( '../views/infostartperson/infopersoninfor.vue')
      },
      { 
        // 账号信息
        path: 'infopersoninfor',
        name: 'accountInfopersoninfor',
        component: () => import( '../views/infostartperson/infopersoninfor.vue')
      },
      { 
        // 选手信息
        path: 'playerinfo',
        name: 'playerinfo',
        component: () => import( '../views/infostartperson/playerinfo.vue')
      },
      { 
        // 我的会员
        path: 'infopersonmember',
        name: 'infopersonmember',
        component: () => import( '../views/infostartperson/infopersonmember.vue')
      },
      { 
        // 我的机构
        path: 'infopersonorgan',
        name: 'infopersonorgan',
        component: () => import( '../views/infostartperson/infopersonorgan.vue')
      },
      { 
        // 我的赛事
        path: 'infopersongame',
        name: 'infopersongame',
        component: () => import( '../views/infostartperson/infopersongame.vue')
      },
      { 
        // 证书
        path: 'book',
        name: 'book',
        component: () => import( '../views/infostartperson/book.vue')
      },
      { 
        // 志愿者
        path: 'volunteer',
        name: 'volunteer',
        component: () => import( '../views/infostartperson/volunteer.vue')
      },
      { 
        // 我的成绩
        path: 'infopersonresult',
        name: 'infopersonresult',
        component: () => import( '../views/infostartperson/infopersonresult.vue')
      },
      { 
        // 我的荣誉
        path: 'infopersonhonor',
        name: 'infopersonhonor',
        component: () => import( '../views/infostartperson/infopersonhonor.vue')
      },
      { 
        // 我的订单
        path: 'infopersonorder',
        name: 'infopersonorder',
        component: () => import( '../views/infostartperson/infopersonorder.vue'),
      },
      { 
        // 订单详情
        path: 'infopersonorderdetails',
        name: 'infopersonorderdetails',
        component: () => import( '../views/infostartperson/infopersonorderdetails.vue')
      },
      {
        // 订单详情
        path: 'infopersongrowup',
        name: 'infopersongrowup',
        component: () => import( '../views/infostartperson/infopersongrowup.vue')
      },
      {
        // 我的报名（个人报名/团体报名）
        path: 'mysignup',
        name: 'personMysignup',
        component: () => import( '../views/mysignup.vue')
      }
    ]
  },
  {
    // 运动员梯队专栏
    path: '/echelon',
    name: 'echelon',
    component: () => import('../views/echelon.vue')
  },
  {
    // 裁判&教练员资质专栏
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/certificate.vue')
  },
  {
    // 科学科普/训练干货
    path: '/knowledge',
    name: 'knowledge',
    component: () => import('../views/knowledge.vue')
  },
  {
    // 证书管理入口
    path: '/certApply',
    name: 'certApply',
    component: () => import('../views/certApply.vue')
  },
  // 注册页（按身份：裁判员 / 培训员 / 学员）
  {
    path: '/register/judge',
    name: 'registerJudge',
    component: () => import('../views/Register.vue'),
    meta: { role: '3' }
  },
  {
    path: '/register/trainer',
    name: 'registerTrainer',
    component: () => import('../views/Register.vue'),
    meta: { role: '5' }
  },
  {
    path: '/register/student',
    name: 'registerStudent',
    component: () => import('../views/Register.vue'),
    meta: { role: '6' }
  },
  // 组织注册页（按组织类型：学校 / 俱乐部 / 协会单位）
  {
    path: '/register/organ',
    name: 'registerOrgan',
    component: () => import('../views/Register.vue'),
    meta: { type: '2', role: '2', orgType: '组织' }
  },
  {
    path: '/register/school',
    name: 'registerSchool',
    component: () => import('../views/Register.vue'),
    meta: { type: '2', role: '2', orgType: '学校' }
  },
  {
    path: '/register/club',
    name: 'registerClub',
    component: () => import('../views/Register.vue'),
    meta: { type: '2', role: '3', orgType: '俱乐部' }
  },
  {
    path: '/register/association',
    name: 'registerAssociation',
    component: () => import('../views/Register.vue'),
    meta: { type: '2', role: '4', orgType: '协会单位' }
  },
  // 如果去的非任何一页面  则跳转首页
  {
    path: '/*',
    // name: 'home',
    component: Home
  }
]

const router = new VueRouter({
  base: '/jumpropeweb/home/',
  routes
})

// 白名单（未登录也可访问的路由地址）
// const whiteList = ['/login', '/404'] // 定义白名单  所有不受权限控制的页面
// 路由的前置守卫
    // state 认证状态   0 待认证 1 认证通过 2 认证拒绝 3 待完善 
// router.beforeEach(function(to, from, next) {
//   NProgress.start() 

//   if(to.path === '/infostart/infoorganinfor'){
//     next()
//     return 

//     if(store.getters.logintoken && store.getters.organInfostate !== 3 ){

//       next()
//     }else{
 
//       next('/')
//     }
//   }else{

//     if(to.path === '/infostartperson/infopersoninfor'){
//       next()
//       return 

//       if(store.getters.logintoken && store.getters.personInfostate === 1 ){

//         next()
//       }else{

//         next('/')
//       }


//     }else{
//       next()
//     }
//   }

 
//   NProgress.done() 
// })
// 手动强制关闭一次  为了解决 手动切换地址时  进度条的不关闭的问题
// // 如果没有token
// if (whiteList.indexOf(to.path) > -1) {
//   // 如果找到了 表示在在名单里面 则放行
//     next()
//   } else {
//     next('/login') // 跳到登录页
//   }
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
